const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      background: theme.colors[4],
      color: theme.colors[1],
      paddingTop: (props) => (props.headerHeight),
      '& .Footer__root': {
        marginTop: 200,
      },
    },
    wrapper: {
      extend: theme.wrapper,
    },
    coverProduct: {
      marginTop: 60,
    },
    description: {
      marginTop: 100,
    },
    text: {
      columnCount: 2,
      columnGap: 80,
      fontSize: 16,
    },
    gallery: {
      marginTop: 200,
      '& .slick-list': {
        width: '80%',
        margin: '0 auto',
        borderRadius: 16,
        overflow: 'hidden',
      },
      '& .Carousel__carouselItem': {
        padding: 0,
      },
      '& .Carousel__carouselImg': {
        position: 'relative',
        zIndex: 1,
        paddingBottom: '54%',
        '& img': {
          width: '100%',
          height: '110%',
        },
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    gallery: {
      marginTop: 80,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    text: {
      columnCount: 1,
      columnGap: 0,
      fontSize: 16,
    },

    gallery: {
      marginTop: 50,
      marginBottom: 50,
      '& .slick-list': {
        width: '100%',
      },
      '& .slick-arrow': {
        display: 'none',
      },
      '& .slick-dots': {
        bottom: -20,
      },
    },
  }

  return output
}

export default style
